 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		49: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		49: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app/" + ({"1":"AssignmentsV2~GradeFilteredContentCards~HomeLearning~InteractiveWorksheetsOverview~MemberHomepage~My~1b1091d7","2":"AssignmentsModalV2~AssignmentsV2~DirectShareWorksheets~KidFrameDetail~MyAssignments~MyStudents~Submi~901084b6","5":"Checkout~Gift~UpdatePayment","6":"vendors~Gift~KidFrame~MyStudents","7":"LandingPage~Pricing","8":"RegistrationModal","10":"AccountSettings","11":"AssignmentsModalV2","12":"AssignmentsV2","13":"BrainzyPaint","14":"Checkout","15":"DirectShareWorksheets","16":"FeaturedArtwork","17":"FillableWorksheet","18":"Gift","19":"GradeFilteredContentCards","20":"GradeWorksheetModal","21":"HomeLearning","22":"InteractiveWorksheetsOverview","23":"KidFrame","24":"KidFrameDetail","25":"LandingPage","26":"MemberHomepage","27":"MyAssignments","28":"MyCollections","29":"MyStudents","30":"Onboarding","31":"PracticeSkill","32":"PredefinedCollectionsDetail","33":"Pricing","34":"ProgressTracker","35":"RelatedGuidedLesson","36":"Reviews","37":"SeasonalDaysDropdown","38":"Sellpage","39":"SubPlansList","40":"SubmissionsReportPage","41":"SwitchAccountModal","42":"TopNav","43":"UpdatePayment","44":"UserMenu","45":"vendors~Gift","46":"vendors~MemberHomepage","47":"vendors~MyStudents"}[chunkId]||chunkId) + "." + {"0":"c64a524b5bc977d76268","1":"5c45a17c6a33f26def66","2":"58eaa08110c813c0cac3","3":"9530a5a77570e1e1da25","4":"60aefd4789addd30c6b0","5":"ec09392659e1d1e16308","6":"dbfe5c59343ad49e5919","7":"a8f2f750c661e73a563d","8":"9a6436bc43481bcb86a6","9":"5c0bc204d33f1d6de10f","10":"01821780a08b0337e66a","11":"6e73e6c0f5792d3016b4","12":"d35cc6d4bd93aff42fc8","13":"bba3cc65e8521b7e7830","14":"76a38177af7faee18cb1","15":"70c7b56f7906694d8850","16":"fb1aa94248d1e819bad5","17":"9350a43f9c0e8335e9f1","18":"489e5bede21f812c6321","19":"c8b3f88df5e9f98d1e95","20":"f321cec733ea33379573","21":"6c347ea1cc27993be874","22":"f56354e389e305b397f8","23":"6f15d09e448630ba1290","24":"817c20d0d1a901448bba","25":"11cbabbd3c51fb48f923","26":"77ee9f8abfce3a217037","27":"be5b4e620393cda88957","28":"e2fb30d90faa6f4d8ea6","29":"139535f0c95c310dddc8","30":"b5ef36fe4f13826fddd2","31":"c3027c21917fd3e12b3a","32":"27e394fb159fc2b5a4d7","33":"a87aa282c22e04715cd0","34":"2b68210911e725febadc","35":"553095f84ac1f527bbcc","36":"199b715f54c4a98e61e8","37":"122c978f7ad261be9ccb","38":"3a53fc748520c9f55c12","39":"f8896c2d47e8c54c7a16","40":"906aaebffac68c734b14","41":"5349bff80bc1629b248f","42":"b3990968f1bd3022dce1","43":"fb2115dbef43063f83a6","44":"b9ad9dd5a7574b239abf","45":"d49c6003788fc924e028","46":"6d557f7ad132e31d50e6","47":"0736c962d0613e2e894e","48":"53375f2dad32b9a4c08c","51":"d97d91c62ce14eb05a87","52":"f3c3fafd4acc4382fb95","53":"b0f80c8f2bb90780755a","54":"3c4146c9a9f6603f91ce"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"5":1,"7":1,"8":1,"10":1,"11":1,"12":1,"14":1,"15":1,"16":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"33":1,"36":1,"37":1,"38":1,"40":1,"42":1,"43":1,"44":1,"45":1,"51":1,"52":1,"53":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app/" + ({"1":"AssignmentsV2~GradeFilteredContentCards~HomeLearning~InteractiveWorksheetsOverview~MemberHomepage~My~1b1091d7","2":"AssignmentsModalV2~AssignmentsV2~DirectShareWorksheets~KidFrameDetail~MyAssignments~MyStudents~Submi~901084b6","5":"Checkout~Gift~UpdatePayment","6":"vendors~Gift~KidFrame~MyStudents","7":"LandingPage~Pricing","8":"RegistrationModal","10":"AccountSettings","11":"AssignmentsModalV2","12":"AssignmentsV2","13":"BrainzyPaint","14":"Checkout","15":"DirectShareWorksheets","16":"FeaturedArtwork","17":"FillableWorksheet","18":"Gift","19":"GradeFilteredContentCards","20":"GradeWorksheetModal","21":"HomeLearning","22":"InteractiveWorksheetsOverview","23":"KidFrame","24":"KidFrameDetail","25":"LandingPage","26":"MemberHomepage","27":"MyAssignments","28":"MyCollections","29":"MyStudents","30":"Onboarding","31":"PracticeSkill","32":"PredefinedCollectionsDetail","33":"Pricing","34":"ProgressTracker","35":"RelatedGuidedLesson","36":"Reviews","37":"SeasonalDaysDropdown","38":"Sellpage","39":"SubPlansList","40":"SubmissionsReportPage","41":"SwitchAccountModal","42":"TopNav","43":"UpdatePayment","44":"UserMenu","45":"vendors~Gift","46":"vendors~MemberHomepage","47":"vendors~MyStudents"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"37f3561d020909d6f9dc","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"50d1d200d8f5c392c7cc","6":"31d6cfe0d16ae931b73c","7":"2b436e69b3b155a4a770","8":"c63eb5aeed3261a64b16","9":"31d6cfe0d16ae931b73c","10":"4ad35bb3dca41c2cae0b","11":"16d8f63ddc7389481ba3","12":"d6aec898f6f0f5215689","13":"31d6cfe0d16ae931b73c","14":"28e08083a8b774da285a","15":"96f10993de42e552b4f0","16":"d56d9288e4c0c7368f48","17":"31d6cfe0d16ae931b73c","18":"7975b8102de7d4dd0e46","19":"cc59a2d5075b55748ffc","20":"78f108ef2a1e16d4d1b4","21":"4c89bea8f7f35505c32a","22":"da18f98999ae97bf95a3","23":"a6d4cc6e8d1fa221284e","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"67bcc2b89df1fb86ef31","27":"112050efe8b36f01caaf","28":"6a9a122d02edd16a7034","29":"a316be6a42c6bf1c9b2e","30":"a0c5b6810eff39972087","31":"5491656ee574e8b4a49d","32":"31d6cfe0d16ae931b73c","33":"3a33133d8b4cb1687191","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"ba9c0fc38afc58c1902d","37":"495c0b9853cb793a31ee","38":"fed495f6ff9f57243990","39":"31d6cfe0d16ae931b73c","40":"05cfc41a18b80aeac5d7","41":"31d6cfe0d16ae931b73c","42":"ddb24ea7ffcfea2391aa","43":"cb30306a496b38be9101","44":"f73ff81cf842ea909b56","45":"ca68f8fa1dd9edae64fc","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","51":"d7fbd1904b7d8ac3ae36","52":"bd778f05e2c6a0cd3ebc","53":"bd778f05e2c6a0cd3ebc","54":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 397);
